var _desc, _defs, _rect, _text, _text2, _path, _path2, _path3, _g, _g2, _g3, _g4, _rect2, _text3, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegratedSearchArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 720",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "\uD1B5\uD569 \uC81C\uD734\uB9C1\uD06C \uAC80\uC0C9 \uD750\uB984") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "36\uB9CC \uAC1C \uC774\uC0C1\uC758 \uC81C\uD734\uB9C1\uD06C\uB97C \uC815\uC81C\uD574 \uD1B5\uD569 \uAC80\uC0C9\uACFC \uD53C\uB4DC\uBC31\uC744 \uAC70\uCCD0 \uB9C1\uD06C \uC0DD\uC131\uC73C\uB85C \uC5F0\uACB0\uD558\uB294 \uB124 \uB2E8\uACC4 \uD750\uB984")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10Z",
    fill: "#43a9df"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .title { fill: #26384b; font-size: 38px; font-weight: 800; letter-spacing: -0.5px; }\n      .subtitle { fill: #748396; font-size: 22px; font-weight: 650; }\n      .label { fill: #26384b; font-size: 38px; font-weight: 800; letter-spacing: -0.4px; }\n      .label-accent { fill: #1377ad; font-size: 38px; font-weight: 800; letter-spacing: -0.4px; }\n      .caption { fill: #748396; font-size: 24px; font-weight: 650; }\n      .metric { fill: #1377ad; font-size: 36px; font-weight: 800; }\n      .metric-label { fill: #748396; font-size: 21px; font-weight: 650; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 38,
    fill: "#fbfcfd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 74,
    className: "title"
  }, "\uAC80\uC0C9\uD574\uC11C \uB9C1\uD06C \uB9CC\uB4E4\uAE30")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 112,
    className: "subtitle"
  }, "\uAE30\uC874 \uB9C1\uD06C \uB370\uC774\uD130\uB97C \uAC80\uC0C9 \uC790\uC0B0\uC73C\uB85C \uC804\uD658\uD55C \uD06C\uB9AC\uC5D0\uC774\uD130 \uC0DD\uC131 \uACBD\uD5D8")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 285 H320",
    fill: "none",
    stroke: "#c9d5de",
    strokeWidth: 5,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580 285 H600",
    fill: "none",
    stroke: "#b5dcea",
    strokeWidth: 5,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M860 285 H880",
    fill: "none",
    stroke: "#8bcbed",
    strokeWidth: 5,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 158,
    width: 240,
    height: 258,
    rx: 28,
    fill: "#f4f7f9",
    stroke: "#dce4ea",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 190,
    width: 120,
    height: 82,
    rx: 18,
    fill: "#ffffff",
    stroke: "#cbd7df",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 217 H208 M136 243 H192",
    stroke: "#91a4b2",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 243,
    r: 9,
    fill: "#69bce6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 344,
    textAnchor: "middle",
    className: "label"
  }, "36\uB9CC+ \uB9C1\uD06C"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 378,
    textAnchor: "middle",
    className: "caption"
  }, "6\uAC1C \uC81C\uD734\uCC98"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 158,
    width: 240,
    height: 258,
    rx: 28,
    fill: "#f1f8fb",
    stroke: "#cfe8f5",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 185 H511 L470 230 V268 L434 286 V230Z",
    fill: "#ffffff",
    stroke: "#69bce6",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 193,
    r: 11,
    fill: "#a7d7ef"
  }), /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 344,
    textAnchor: "middle",
    className: "label"
  }, "URL \uC815\uC81C"), /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 378,
    textAnchor: "middle",
    className: "caption"
  }, "\uD544\uD130 \xB7 \uC911\uBCF5 \uC81C\uAC70"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 158,
    width: 240,
    height: 258,
    rx: 28,
    fill: "#eef8fd",
    stroke: "#b9def1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 235,
    r: 46,
    fill: "#ffffff",
    stroke: "#43a9df",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 267 L770 291",
    stroke: "#43a9df",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 235 H738 M714 211 V259",
    stroke: "#b9def1",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 344,
    textAnchor: "middle",
    className: "label-accent"
  }, "\uD1B5\uD569 \uAC80\uC0C9"), /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 378,
    textAnchor: "middle",
    className: "caption"
  }, "\uAC80\uC0C9 \xB7 \uD53C\uB4DC\uBC31"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 158,
    width: 256,
    height: 258,
    rx: 28,
    fill: "#e8f6fd",
    stroke: "#8ccfee",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 235,
    r: 58,
    fill: "#ffffff",
    stroke: "#56b2df",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 235 L1009 258 L1055 211",
    fill: "none",
    stroke: "#1377ad",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 344,
    textAnchor: "middle",
    className: "label-accent"
  }, "\uB9C1\uD06C \uC0DD\uC131"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 378,
    textAnchor: "middle",
    className: "caption"
  }, "71% \uC0DD\uC131 \uC804\uD658"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 448,
    width: 600,
    height: 56,
    rx: 28,
    fill: "#eaf6fc"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 484,
    textAnchor: "middle",
    className: "caption",
    fill: "#3689b5"
  }, "\uD0A4\uC6CC\uB4DC + \uC758\uBBF8 \uAE30\uBC18 \uAC80\uC0C9 \xB7 RRF \uB7AD\uD0B9 \uC124\uACC4")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 548,
    width: 280,
    height: 104,
    rx: 24,
    fill: "#ffffff",
    stroke: "#dce4ea",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 592,
    textAnchor: "middle",
    className: "metric"
  }, "4,900\uBA85"), /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 624,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uAC80\uC0C9 \uC774\uC6A9 \uD06C\uB9AC\uC5D0\uC774\uD130"), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 548,
    width: 280,
    height: 104,
    rx: 24,
    fill: "#ffffff",
    stroke: "#cfe8f5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 592,
    textAnchor: "middle",
    className: "metric"
  }, "3.3\uB9CC \uAC80\uC0C9"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 624,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uC624\uD508 3\uC8FC \uB204\uC801"), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 548,
    width: 280,
    height: 104,
    rx: 24,
    fill: "#ffffff",
    stroke: "#b9def1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 932,
    y: 592,
    textAnchor: "middle",
    className: "metric"
  }, "40%+"), /*#__PURE__*/React.createElement("text", {
    x: 932,
    y: 624,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uC2E0\uADDC 7\uC77C \uB0B4 \uCCAB \uB9C1\uD06C \uC0DD\uC131"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedSearchArchitecture);
export default __webpack_public_path__ + "static/media/integrated-search-architecture.f9d3b138ea92c0fcf1428c8f3e0e6e12.svg";
export { ForwardRef as ReactComponent };